import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { TranslateFunction } from 'react-localize-redux';

import { LinkIcon } from '../../atoms/LinkIcon';
import { Phone } from '../../icons/Phone';
import { InfoBox } from '../../molecules/InfoBox/InfoBox';

const useStyles = makeStyles((theme: Theme) => ({
  phoneNumberContainer: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(11),
  },
  phoneNumberLink: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up('md')]: {
    phoneNumberContainer: {
      margin: 0,
    },
  },
  [theme.breakpoints.down('xs')]: {
    phoneNumberLink: {
      '&:hover': {
        backgroundColor: theme.palette.grey[400],
      },
    },
  },
}));

export type Props = {
  restaurantPhoneNumber: string;
  translate: TranslateFunction;
};

export function ContactRestaurantInfoBox({
  restaurantPhoneNumber,
  translate,
}: Props): JSX.Element {
  const classes = useStyles({});

  const contactRestaurantStyles = clsx(
    'fd-contact-restaurant',
    classes.phoneNumberContainer,
  );
  return (
    <InfoBox
      className={contactRestaurantStyles}
      action={
        <LinkIcon
          className={classes.phoneNumberLink}
          href={`tel:${restaurantPhoneNumber}`}
          label={`${translate('OrderDetails_contactRestaurant')}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Phone />
        </LinkIcon>
      }
      title={`${translate('OrderDetails_contactRestaurant')}`}
      subTitle={restaurantPhoneNumber}
    />
  );
}
